export const getStyles = (_, { palette = {} } = {}) => {
  const stepContainer = {
    display: 'flex',
    flexFlow: 'column',
    height: '100%',
  };

  const stepContent = {
    flex: 1,
    'overflow-y': 'auto',
    'overflow-x': 'hidden',
  };

  const title = {
    fontStyle: 'normal',
    fontWeight: 600,
    fontSize: '26px',
    lineHeight: '28px',
    color: palette.neutralPrimary,
    marginLeft: '26px',
    marginTop: '32px',
    marginBottom: '16px',
  };

  return {
    stepContainer,
    stepContent,
    title,
  };
};

export const getFooterStyles = (_, { palette = {} } = {}) => {
  const footerContainer = {
    display: 'flex',
    flexFlow: 'column',
    padding: '16px 24px',
    borderTop: `1px solid ${palette.neutralLight}`,
    bottom: 0,
  };

  const footerButtons = {
    display: 'flex',
    flexFlow: 'row',
  };

  const cancel = {};

  const primary = {
    marginLeft: '8px',
    marginRight: '40px',
  };

  const start = {
    marginLeft: '8px',
    marginRight: '12px',
  };

  const secondary = {
    marginLeft: '8px',
  };

  const link = {
    marginLeft: '18px',
    color: '#0078d4',
    textDecoration: 'underline',
    backgroundColor: 'transparent',
    border: 'none',
  };

  const basicLink = {
    marginLeft: '18px',
    textDecoration: 'none',
    backgroundColor: 'transparent',
    border: 'none',
    color: '#0078d4',
    fontWeight: 200,
  };

  return {
    footerContainer,
    footerButtons,
    cancel,
    primary,
    start,
    secondary,
    link,
    basicLink,
  };
};
